import { cva } from 'class-variance-authority'

export const radioCardVariants = cva(
  'flex p-6 pb-6.5 rounded border transition-all duration-150 cursor-pointer',
  {
    variants: {
      state: {
        default:
          'border-main-border-default bg-main-background-card shadow-outline hover:border-main-border-bold hover:border-main-border-bold hover:bg-main-background-card hover:shadow-outline',
        selected: 'border-main-border-focus bg-main-background-card shadow-outline',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  },
)
